import { createSlice } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { showSuccessToast } from '../../app/utils/tostify';
import {
	getDatasheet,
	getDatasheetList,
	getDatasheetPriceAndInventory,
	uploadFileRecordStatus,
	validationApproveAllForDatasheet
} from '../apis/datasheetAPIs';

interface initialStateInterFace {
	error: any;
	loading: boolean;
	dataSheetList: Array<any>;
	count: number;
	currentPage: number;
}

const initialState: initialStateInterFace = {
	loading: false,
	error: [],
	dataSheetList: [],
	count: 0,
	currentPage: 1
};
const dataSheet = createSlice({
	name: 'productSlice',
	initialState,
	reducers: {
		resetState(state) {
			state.loading = false;
			state.error = [];
		},
		updateCurrentPage(state, action) {
			state.currentPage = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder.addCase(
			getDatasheet.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			getDatasheet.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.error = '';
			}
		);
		builder.addCase(
			getDatasheet.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			getDatasheetPriceAndInventory.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			getDatasheetPriceAndInventory.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.error = '';
			}
		);
		builder.addCase(
			getDatasheetPriceAndInventory.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			uploadFileRecordStatus.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			uploadFileRecordStatus.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(
			uploadFileRecordStatus.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			getDatasheetList.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			getDatasheetList.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.error = '';
				state.dataSheetList = action?.payload?.data?.list;
				state.count = action?.payload?.data?.count;
			}
		);
		builder.addCase(
			getDatasheetList.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			validationApproveAllForDatasheet.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			validationApproveAllForDatasheet.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.error = '';
			}
		);
		builder.addCase(
			validationApproveAllForDatasheet.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
	}
});
export const { resetState } = dataSheet.actions;
export default dataSheet.reducer;
